import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { LoyaltyQrResponse } from '@user/const';
import { Observable } from 'rxjs';
import { CustomUserActions } from '../store/actions';
import { CustomUserSelectors } from '../store/selectors';
import { StateWithCustomUser } from '../store/user-state';

@Injectable({ providedIn: 'root' })
export class LoyaltyQrFacade {
  constructor(private store: Store<StateWithCustomUser>) {}

  getLoyaltyQr(): Observable<LoyaltyQrResponse> {
    return this.store.pipe(select(CustomUserSelectors.getLoyaltyQrValue));
  }

  loadLoyaltyQr(): void {
    this.store.dispatch(new CustomUserActions.LoadLoyaltyQr());
  }
}
